import type { RouteRecordRaw } from 'vue-router';
import { CUSTOMER_REVIEW_ROUTE_NAME, REVIEW_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const reviewsRoutes: RouteRecordRaw = {
  path: '/reviews',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: REVIEW_ROUTE_NAME.LIST_REVIEW,
      path: '',
      component: () => import('./Reviews.vue'),
    },
  ],
};

export const reviewRedirects: RouteRecordRaw[] = [
  { path: '/review/customer-review', redirect: { name: CUSTOMER_REVIEW_ROUTE_NAME.CUSTOMER_REVIEW } },
  { path: '/review/reviews', redirect: { name: REVIEW_ROUTE_NAME.LIST_REVIEW } },
  { path: '/review', redirect: { name: REVIEW_ROUTE_NAME.LIST_REVIEW } },
];
